import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatorCoreModule } from '../../../../../creator-core/creator-core.module';

import { FileUploadComponent } from './fu/file-upload.component';
import { FileUploadManager } from './fu-manager/fu-manager.component';
import { FileUploadEditModalComponent } from './fu-manager/fu-edit-modal/fu-edit-modal.component';
import { FileUploadGridViewComponent } from './fu-manager/fu-grid-view/fu-grid-view.component';
import { FileUploadListViewComponent } from './fu-manager/fu-list-view/fu-list-view.component';
import { FileUploadManagerService } from './services/fu-manager.service';

import { FileUploadSizePipe } from './pipes/fu-file-size.pipe';
import { FileUploadNamePipe } from './pipes/fu-file-name.pipe';
import { FileUploadOrderByPipe } from './pipes/fu-order-by.pipe';
import { FileUploadTimeAgoPipe } from './pipes/fu-time-ago.pipe';
import { FileUploadToClassPipe } from './pipes/fu-to-class.pipe';

@NgModule({
	imports: [CommonModule, CreatorCoreModule],
	declarations: [
		FileUploadComponent,
		FileUploadManager,
		FileUploadEditModalComponent,
		FileUploadGridViewComponent,
		FileUploadListViewComponent,
		FileUploadNamePipe,
		FileUploadSizePipe,
		FileUploadOrderByPipe,
		FileUploadTimeAgoPipe,
		FileUploadToClassPipe
	],
	exports: [
		FileUploadComponent,
		FileUploadManager,
		FileUploadEditModalComponent,
		FileUploadGridViewComponent,
		FileUploadListViewComponent
	],
	providers: [FileUploadManagerService]
})
export class FileUploadModule {}
